import { Component, input } from '@angular/core';

import { LandingText } from '../landing.types';
import { LandingGlow } from './landing-glow.component';
import { RevealOnScrollDirective } from './reveal-on-scroll.directive';

@Component({
    selector: 'app-landing-benefits',
    standalone: true,
    imports: [LandingGlow, RevealOnScrollDirective],
    templateUrl: './landing-benefits.component.html',
    styleUrl: './landing-benefits.component.scss'
})
export class LandingBenefits {
    readonly text = input.required<LandingText>();

    // One icon per card, matching the order of benefitsCards.
    readonly benefitsIcons = ['pi-shield', 'pi-bolt', 'pi-clock', 'pi-chart-line', 'pi-sitemap', 'pi-thumbs-up'];
}
